/** Asks for the reason a void, unlock or rejection needs, then confirms. */
import { useState } from 'react';
import { Alert, Button, Field, Modal, inputClass } from './ui';

export function ReasonDialog({
  title,
  description,
  confirmLabel,
  tone = 'danger',
  withDate = false,
  error,
  busy,
  onConfirm,
  onClose,
}: {
  title: string;
  description?: string;
  confirmLabel: string;
  tone?: 'danger' | 'primary';
  withDate?: boolean;
  error?: string | null;
  busy?: boolean;
  onConfirm: (reason: string, date?: string) => void;
  onClose: () => void;
}): JSX.Element {
  const [reason, setReason] = useState('');
  const [date, setDate] = useState('');
  return (
    <Modal title={title} description={description} onClose={onClose}>
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          onConfirm(reason.trim(), date || undefined);
        }}
      >
        {error && <Alert tone="critical">{error}</Alert>}
        <Field label="Reason" required hint="Kept in the audit trail.">
          <textarea className={inputClass} rows={3} required minLength={3} value={reason} onChange={(e) => setReason(e.target.value)} autoFocus />
        </Field>
        {withDate && (
          <Field label="Date for the reversal" hint="Leave blank to use the original date when its period is still open.">
            <input type="date" className={inputClass} value={date} onChange={(e) => setDate(e.target.value)} />
          </Field>
        )}
        <div className="flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" variant={tone} busy={busy} disabled={reason.trim().length < 3}>
            {confirmLabel}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
